import { render, staticRenderFns } from "./Illuminazione.vue?vue&type=template&id=cc676444&"
import script from "./Illuminazione.vue?vue&type=script&lang=js&"
export * from "./Illuminazione.vue?vue&type=script&lang=js&"
import style0 from "./Illuminazione.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports